module.exports = __webpack_public_path__ + "static/media/ramp.b8bd3ecd.png";